/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LandlordSlaContractDto } from './LandlordSlaContractDto';
import {
    LandlordSlaContractDtoFromJSON,
    LandlordSlaContractDtoFromJSONTyped,
    LandlordSlaContractDtoToJSON,
    LandlordSlaContractDtoToJSONTyped,
} from './LandlordSlaContractDto';

/**
 * 
 * @export
 * @interface CreateLandlordPartnerResponseDto
 */
export interface CreateLandlordPartnerResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateLandlordPartnerResponseDto
     */
    relationshipId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLandlordPartnerResponseDto
     */
    partnerOrgId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLandlordPartnerResponseDto
     */
    partnerName: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLandlordPartnerResponseDto
     */
    isSameCompanyAsOperator: boolean;
    /**
     * 
     * @type {LandlordSlaContractDto}
     * @memberof CreateLandlordPartnerResponseDto
     */
    slaContract?: LandlordSlaContractDto | null;
}

/**
 * Check if a given object implements the CreateLandlordPartnerResponseDto interface.
 */
export function instanceOfCreateLandlordPartnerResponseDto(value: object): value is CreateLandlordPartnerResponseDto {
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    if (!('partnerOrgId' in value) || value['partnerOrgId'] === undefined) return false;
    if (!('partnerName' in value) || value['partnerName'] === undefined) return false;
    if (!('isSameCompanyAsOperator' in value) || value['isSameCompanyAsOperator'] === undefined) return false;
    return true;
}

export function CreateLandlordPartnerResponseDtoFromJSON(json: any): CreateLandlordPartnerResponseDto {
    return CreateLandlordPartnerResponseDtoFromJSONTyped(json, false);
}

export function CreateLandlordPartnerResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLandlordPartnerResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'],
        'partnerOrgId': json['partnerOrgId'],
        'partnerName': json['partnerName'],
        'isSameCompanyAsOperator': json['isSameCompanyAsOperator'],
        'slaContract': json['slaContract'] == null ? undefined : LandlordSlaContractDtoFromJSON(json['slaContract']),
    };
}

export function CreateLandlordPartnerResponseDtoToJSON(json: any): CreateLandlordPartnerResponseDto {
    return CreateLandlordPartnerResponseDtoToJSONTyped(json, false);
}

export function CreateLandlordPartnerResponseDtoToJSONTyped(value?: CreateLandlordPartnerResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'partnerOrgId': value['partnerOrgId'],
        'partnerName': value['partnerName'],
        'isSameCompanyAsOperator': value['isSameCompanyAsOperator'],
        'slaContract': LandlordSlaContractDtoToJSON(value['slaContract']),
    };
}

